<ng-container *ngIf="useMatCard; else regularDisplay">
  <mat-card
    class="top-card mat-elevation-z0 overflowHidden display-not-executed-history-mat-card"
  >
    <ng-container *ngTemplateOutlet="componentContent"></ng-container>
  </mat-card>
</ng-container>
<ng-template #regularDisplay>
  <ng-container *ngTemplateOutlet="componentContent"></ng-container>
</ng-template>
<ng-template #componentContent>
  <div *ngIf="title?.length > 0" class="strong mb-2">{{ title }}</div>
  <div class="display-info">
    <div class="author-info">
      <div *ngIf="notExecutedHistoryItem.author != null">
        {{
          notExecutedHistoryItem.author.firstName
            | personName : notExecutedHistoryItem.author.lastName
        }}
      </div>
      <div>
        {{
          notExecutedHistoryItem.createdTimestamp
            | formatDate : '' : 'dd/MM/yyyy'
        }}
      </div>
    </div>
    <div class="not-executed-info">
      <textarea-with-label
        [label]="'Reden'"
        [placeholder]="'Noteer waarom de opdracht niet kon uitgevoerd worden'"
        [(ngModel)]="notExecutedHistoryItem.content"
        [disabled]="!editable"
        (ngModelChange)="saved = false"
      ></textarea-with-label>
      <div class="d-flex yes-no-container">
        <label>Bellen met <b>Inpress</b>. (03 825 40 16)</label>
        <div class="d-flex justify-content-between">
          <yes-no
            [value]="notExecutedHistoryItem.callInpress"
            [neverShowExtraInstructions]="true"
            [nullIsFalse]="false"
            [flexRow]="false"
            [disabled]="!editable"
            (answer)="setCallInpress($event)"
          ></yes-no>
          <span
            class="font-italic"
            *ngIf="
              !!notExecutedHistoryItem.inpressCommunicationRegistration?.by
            "
          >
            ({{
              notExecutedHistoryItem.inpressCommunicationRegistration.by
                ?.firstName
                | personName
                  : notExecutedHistoryItem.inpressCommunicationRegistration.by
                      ?.lastName
            }},
            {{
              notExecutedHistoryItem.inpressCommunicationRegistration.date
                | date : 'dd/MM/yyyy HH:mm'
            }})
          </span>
        </div>
      </div>
      <textarea-with-label
        *ngIf="!!notExecutedHistoryItem.callInpress"
        [label]="'Met wie heb je gebeld'"
        [placeholder]="'voornaam naam / telefoonnummer / gsm'"
        [(ngModel)]="notExecutedHistoryItem.inpressCommunicationSummary"
        [disabled]="!editable"
        (ngModelChange)="saved = false"
      ></textarea-with-label>
      <div class="d-flex yes-no-container">
        <label>Bellen met <b>makelaar</b>.</label>
        <div class="d-flex justify-content-between">
          <yes-no
            [value]="notExecutedHistoryItem.callClient"
            [neverShowExtraInstructions]="true"
            [nullIsFalse]="false"
            [flexRow]="false"
            [disabled]="!editable"
            (answer)="setCallClient($event)"
          ></yes-no>
          <span
            class="font-italic"
            *ngIf="!!notExecutedHistoryItem.clientCommunicationRegistration?.by"
          >
            ({{
              notExecutedHistoryItem.clientCommunicationRegistration.by
                ?.firstName
                | personName
                  : notExecutedHistoryItem.clientCommunicationRegistration.by
                      ?.lastName
            }},
            {{
              notExecutedHistoryItem.clientCommunicationRegistration.date
                | date : 'dd/MM/yyyy HH:mm'
            }})
          </span>
        </div>
      </div>
      <textarea-with-label
        *ngIf="!!notExecutedHistoryItem.callClient"
        [label]="'Met wie heb je gebeld'"
        [placeholder]="'voornaam naam / telefoonnummer / gsm'"
        [(ngModel)]="notExecutedHistoryItem.clientCommunicationSummary"
        [disabled]="!editable"
        (ngModelChange)="saved = false"
      ></textarea-with-label>

      <textarea-with-label
        [label]="'Wat moet er gebeuren of werd al afgesproken'"
        [(ngModel)]="notExecutedHistoryItem.suggestedFollowUp"
        [disabled]="!editable"
        (ngModelChange)="saved = false"
      ></textarea-with-label>

      <ng-container *ngIf="subProject.type !== 'Repo'">
        <div class="d-flex yes-no-container">
          <label>{{ stockedAtBranchSubtitle }}</label>
          <div class="d-flex justify-content-between">
            <yes-no
              [value]="stockedAtBranch"
              [neverShowExtraInstructions]="true"
              [nullIsFalse]="false"
              [flexRow]="false"
              [disabled]="!editable"
              (answer)="setStockedAtBranch($event); saved = false"
            ></yes-no>
          </div>
        </div>
        <ng-container *ngIf="stockedAtBranch">
          <ng-container *ngIf="!editable; else branchSelect">
            <textarea-with-label
              *ngIf="notExecutedHistoryItem.stockAtBranch != null"
              [label]="'Waar: duid het filiaal aan:'"
              [ngModel]="notExecutedHistoryItem.stockAtBranch.name"
              [disabled]="true"
              (ngModelChange)="saved = false"
            ></textarea-with-label>
          </ng-container>
          <ng-template #branchSelect>
            <div class="d-flex">
              <label class="select-label">Waar: duid het filiaal aan:</label>
              <mat-form-field class="select-field" appearance="outline">
                <mat-select
                  matInput
                  placeholder="Filiaal"
                  [(ngModel)]="notExecutedHistoryItem.stockAtBranch"
                  [compareWith]="compareBranches"
                  (ngModelChange)="saved = false"
                >
                  <mat-option
                    *ngFor="let option of branchOptions"
                    [value]="option"
                  >
                    {{ option.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>

      <div class="upper-space">
        <textarea-with-label
          [label]="'Online feedback*'"
          [placeholder]="'Noteer de reden - de klant leest deze info online'"
          [(ngModel)]="notExecutedHistoryItem.onlineInfo"
          [disabled]="!editable"
          [formControl]="onlineInfoCtrl"
          (ngModelChange)="saved = false"
          class="online-info-field"
        ></textarea-with-label>
      </div>

      <div *ngIf="editable" class="upper-space float-right">
        <mat-spinner
          *ngIf="savingInfo"
          color="primary"
          diameter="24"
        ></mat-spinner>
        <button
          *ngIf="!savingInfo"
          class="button"
          [class.saved]="saved"
          mat-flat-button
          (click)="saveNotExecutedInfo()"
        >
          {{ !saved ? 'Sla info op' : 'Opgeslagen' }}
        </button>
      </div>
    </div>
    <div class="not-executed-assets">
      <img
        *ngIf="firstAsset?.asset != null"
        class="clickable"
        [src]="'/api/assets/' + firstAsset.asset.uuid"
        (click)="openLightbox()"
      />
    </div>
  </div>

  <ng-container *ngIf="!displayOnly">
    <hr />
    <div class="d-flex more-upper-space">
      <mat-radio-group
        class="radio-button-group"
        [(ngModel)]="selectedHandleOption"
        (ngModelChange)="selectedHandleOptionChanged()"
      >
        <mat-radio-button [value]="HowToHandleOption.REMOVE_FROM_CURRENT_TOUR"
          ><b>Terug inplannen:</b> a.s.a.p. - zonder afspraak</mat-radio-button
        >
        <mat-radio-button [value]="HowToHandleOption.RESCHEDULE_APPOINTMENT"
          ><b>Terug inplannen:</b> afspraak nodig</mat-radio-button
        >
        <mat-radio-button [value]="HowToHandleOption.DELAY"
          ><b>Uitstellen:</b> naar de lijst 'uitgesteld'</mat-radio-button
        >
        <mat-radio-button
          *ngIf="subProject.type !== 'Repo'"
          [value]="HowToHandleOption.INVOICE_PARTIALLY"
          ><b>Naar facturatie:</b> bedrag manueel door ADMIN invullen bij
          afwijkende prijzen</mat-radio-button
        >
        <mat-radio-button
          *ngIf="subProject.type === 'Repo'"
          [value]="HowToHandleOption.SET_STATUS_TO_EXECUTED"
          ><b>Uitgevoerd:</b> opdracht blijft zichtbaar in de
          lijst(en)</mat-radio-button
        >
        <mat-radio-button [value]="HowToHandleOption.SET_STATUS_TO_NOT_EXECUTED"
          >Haal uit opdrachtenflow</mat-radio-button
        >
      </mat-radio-group>

      <div class="additional-input">
        <ng-container *ngIf="selectedHandleOption === HowToHandleOption.DELAY">
          <div>
            <textarea-with-label
              [label]="'Reden uitgesteld'"
              [minWidth]="500"
              [(ngModel)]="delayedReason"
            ></textarea-with-label>

            <div class="d-flex">
              <label class="select-label">Opvolgen</label>
              <mat-form-field class="select-field" appearance="outline">
                <mat-select
                  matInput
                  placeholder="Kies medewerker"
                  [(ngModel)]="delayHandler"
                  [compareWith]="compareEntities"
                >
                  <mat-option
                    *ngFor="let option of delayHandlerOptions"
                    [value]="option"
                  >
                    {{
                      option.user?.firstName
                        | personName : option.user?.lastName
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="d-flex">
              <label class="select-label">Datum</label>
              <mat-form-field class="select-field" appearance="outline">
                <input
                  matInput
                  [matDatepicker]="handleDelayByDatePicker"
                  placeholder="Selecteer een datum"
                  [(ngModel)]="handleDelayByDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="handleDelayByDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #handleDelayByDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </ng-container>

        <div
          *ngIf="
            selectedHandleOption === HowToHandleOption.REMOVE_FROM_CURRENT_TOUR
          "
        >
          <mat-form-field appearance="outline">
            <input
              matInput
              [min]="today"
              [matDatepicker]="newTourDatePicker"
              placeholder="Selecteer een datum"
              [(ngModel)]="newTourDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="newTourDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #newTourDatePicker></mat-datepicker>
          </mat-form-field>
          <div *ngIf="employeeOptions?.length > 0">
            <mat-form-field appearance="outline">
              <mat-select
                matInput
                placeholder="Kies een installateur"
                [(ngModel)]="newTourEmployee"
                [compareWith]="compareEntities"
              >
                <mat-option
                  *ngFor="let option of employeeOptions"
                  [value]="option"
                >
                  <span>{{
                    option.user?.firstName | personName : option.user?.lastName
                  }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <button
            class="button"
            mat-flat-button
            (click)="resetNewTourSelection()"
            [disabled]="newTourEmployee == null && newTourDate == null"
          >
            Reset keuzes
          </button>
        </div>

        <div
          *ngIf="
            selectedHandleOption === HowToHandleOption.RESCHEDULE_APPOINTMENT
          "
        >
          <mat-form-field appearance="outline">
            <input
              matInput
              [matDatepicker]="appointmentFollowUpDatePicker"
              placeholder="Selecteer een datum"
              [(ngModel)]="appointmentFollowUpDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="appointmentFollowUpDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #appointmentFollowUpDatePicker></mat-datepicker>
          </mat-form-field>
          <div *ngIf="appointmentEmployeeOptions?.length > 0">
            <mat-form-field appearance="outline">
              <mat-select
                matInput
                placeholder="Kies een medewerker"
                [(ngModel)]="appointmentFollowUpEmployee"
                [compareWith]="compareEntities"
              >
                <mat-option
                  *ngFor="let option of appointmentEmployeeOptions"
                  [value]="option"
                >
                  <span>{{
                    option.user?.firstName | personName : option.user?.lastName
                  }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <button
            class="button"
            mat-flat-button
            (click)="resetAppointmentFollowUpSelection()"
            [disabled]="
              appointmentFollowUpEmployee == null &&
              appointmentFollowUpDate == null
            "
          >
            Reset keuzes
          </button>
        </div>
      </div>

      <div class="send-mail-container">
        <div
          *ngIf="contactName?.length > 0 && contactEmail?.length > 0"
          class="clickable send-mail-button"
        >
          <a
            href="{{
              contactEmail
                | mailSubjectBodyLink
                  : project.id
                  : contactName
                  : subProject.projectPlacement?.address?.line1
                  : subProject.projectPlacement?.address?.city
                  : subProject.projectPlacement?.address?.postalCode
                  : ''
                  : 'Job'
            }}"
            target="_blank"
            >Mail naar klant</a
          >
        </div>
      </div>
    </div>

    <div class="more-upper-space d-flex justify-content-end">
      <mat-spinner
        *ngIf="submitting"
        color="primary"
        diameter="24"
      ></mat-spinner>
      <button
        *ngIf="!submitting"
        class="button"
        mat-flat-button
        (click)="submitHandleNotExecuted()"
      >
        Opslaan
      </button>
    </div>
  </ng-container>
</ng-template>
